const en = {
  // 导航栏
  home: 'Home Page',
  businessCop: 'Business Cooperation',
  companyName: 'Xianwen',
  productService: 'Product Service',
  modao: 'Modao',
  mohe: 'Mohe',
  aboutus: ' About Us',
  solution: 'Solution',
  introduceCom: 'Company Introduction',
  joinUs: 'Join Us',
  allTitle: '先问-多行业领域科技赋能整体方案提供商',

  // 底部
  customizationSolution: '定制化风控解决方案',
  intelligentDecision: '智能决策引擎',
  productIntroduce: 'Product Introduction',
  modaoSolution: 'Modao One-Stop Payday Loan Solution',
  moheSolution: 'Mohe-Automatic AI Risk Control Solution',
  applyUse: 'Request a Trial',

  //home
  bannerTitle: 'Comprehensive Solution Provider of Empowerment Technology for Multiple Industries and Fields',
  bannerTip1: 'Xianwen Technology focuses on creating successful technical solutions for multiple industries and fields such as e-commerce, FinTech, software services, etc.',
  bannerTip2: 'Provide you with customized development services and standard industry products, help partners quickly realize intelligent transformation, and enhance business value and industry competitiveness.',

  productDes: 'Xianwen provides partners with efficient and professional technical solutions and great product services,<br>making your performance unique, and making success at your fingertips.',

  eshop: 'E-Commerce Platform',
  eshopDetail1: 'Cross-Border<br>E-Commerce Platform',
  eshopDetail2: 'Community O2O Platform',
  eshopDetail3: 'Consumption<br>E-Commerce Platform',
  eshopDetail4: 'Maternal and Infant<br>E-Commerce Platform',

  fintech: 'FinTech',
  fintechDetail1: 'Payday Loan Platform System',
  fintechDetail2: 'Anti-Fraud Risk Control System',
  fintechDetail3: 'Loan Supermarket System',
  fintechDetail4: 'Intelligent Outbound<br>Calling System',

  saas: 'Enterprise Software',
  saasDetail1: 'CRM Management Platform',
  saasDetail2: 'OA Management Platform',

  thingsnet: 'Internet of Things',
  thingsnetDetail1: 'ThinkHome Smart Home',
  thingsnetDetail2: 'ThinkHome Smart Office',

  serviceDes: 'Whether it is customized development or standardized products, we can provide you with the best services,<br>helping you better focus on business and improve efficiency.',

  customizonDev: 'Customized Development',
  customizonTip1: 'Efficient R&D Team',
  customizonTip2: 'Professional Demand Team',

  standardProduct: 'Standard Industry Products',
  standardProductTip1: 'Highly-Reputable Products',
  standardProductTip2: 'Full-Process Solutions',

  extraDomain: 'Scalable Field R&D',
  extraDomainTip1: 'Constantly Explore New Fields',
  extraDomainTip2: 'Accept Challenges from New Industries',

  outfootprint:  'Our Footprint',
  singapore: 'Singapore',
  singaporeAddress: '8 Marina Boulevard #14-03A<br>Marina Bay Financial Centre Tower 1',
  china: 'China',
  chinaAddress: 'Block D, Beida Dream Factory, Yuhang District, Hangzhou City',
  india: 'India',
  indiaAddress: 'Site no # 9, 1st C Main Road, Jakkasandra Extension, 1st Block Koramangala, Bengaluru, Karnataka 560034',
  indonesia: 'Indonesia',
  indonesiaAddress: 'Jl. Boulevard Timur, RT.1/RW.12, Pegangsaan Dua, Kec. Klp. Gading, Kota Jkt Utara, Daerah Khusus Ibukota Jakarta 14250, Indonesia',

  partner: 'Partners',

  //商务 合作
  contactUs: 'Contact Us',
  name: 'Name',
  phone: 'Phone',
  email: 'E-Mail',
  requirement: 'Your Requirement',
  submit: 'Submit',

  //解决方案
  solutionTitle: 'E-commerce Solutions',
  solutionDes: 'An enterprise-level e-commerce platform provider, providing e-commerce platform setting-up and<br>solution services for enterprise-level merchants.',

  eshopPlatform: 'Cross-Border E-Commerce Platform',
  o2oPlatform: 'Community O2O Platform',
  consumePlatform: 'Consumption<br>E-Commerce Platform',
  momPlatform: 'Maternal and Infant E-Commerce Platform',

  eshopPlatformDesc: 'Solve the filing of commodities, merchants, customs and border inspection systems,<br>cross-border payment of orders and one-click customs declaration.',
  o2oPlatformDesc: 'For community industries, we provide multiple sales terminals, improve online and offline joint business operations, and build an ecological chain of the Internet + community e-commerce system.',
  consumePlatformDesc: 'For chain convenience stores, shops, department stores and other retail forms in the form of franchise, direct sales, retail, etc.',
  momPlatformDesc: 'Based on the characteristics of the maternal and infant industry, open up the online and offline channels, and build a complete network-wide marketing system.',

  knowMore: 'Learn More',
  advantage: 'Our Advantages',

  fintechTitle: 'FinTech Solutions',
  fintechDesc: 'Explore the sea of stars in the field of FinTech',
  modaoDesc: 'Overseas Payday Loan One-Stop Solution',
  modaoDetail: 'Provide overseas Fintech one-stop products and technical services, perfect solution to business start-up, system setting-up, and output operation mode.',
  moheDesc: 'Overseas Automatic Big Data Risk Control System',
  moheDetail: 'Intelligent risk control solution combining big data + AI technology',

  saasDesc: 'Enterprise Software Development',

  thingsDesc: 'Internet of Things Solutions',
  thinkHome: 'ThinkOffice Smart Home (in development)',
  thinkHomeDetail: 'Whole-house intelligent one-stop service, we understand what you want, and let you truly enjoy a warm and comfortable living environment.',
  thinkoffice: 'ThinkOffice Smart Office (in development)',
  thinkofficeDetail: 'Intelligent company management service, helping to improve office efficiency and quality, improving office conditions, and realizing visual and scientific management.',

  //mohe
  overseasMohe: 'Overseas Automatic Big Data Risk Control System',
  dataDes: 'Based on Massive Data Sources',
  dataNumber1: 'Overseas Borrower Data',
  dataNumber2: 'Overseas Borrower Behavior Data',
  dataNumber3: 'Overseas User Identity Data',

  sixAdvantage: '6 Core Advantages',
  advantageBlacklist: 'Multi-data source blacklist hits the database, directly refuse blacklisted overseas borrowers.',
  advantageReview: 'Automatic review process, no manual intervention, reducing the operating and management costs',
  advantageResult: 'Review and get a result within 1minute, reducing user waiting time, improving product experience, and start quickly',
  advantageChidu: 'Adjustable risk control review scale, reasonable allocation based on operating costs',
  advantageOverdue: 'Traceable channels to check overdue performance, reasonable operation',
  advantageLead: 'Stay ahead of the industry in first overdue and overdue performance',

  beginService: 'Join us now and start serving!',
  experienceNow: 'Try it Now',


  //modao
  difficultDesc: 'Xianwen provides partners with efficient and professional technical solutions and great product services, making your performance unique, and making success at your fingertips.',

  settleDifficult: 'Registration Difficulties',
  settle1: 'How to get the license done?',
  settle2: 'How to recruit and manage?',
  settle3: 'How to get funds-in/<br>funds-out?',

  techDifficult: 'Technical Difficulties',
  tech1: 'How to set up the whole process of the system？',
  tech2: 'How to handle the app market？',
  tech3: 'How to develop the risk control process？',

  runDifficulr: 'Operating Difficulties',
  run1: 'How to get the traffic promotion done？',
  run2: 'How to manage the ripening team？',
  run3: 'How to calculate the overseas accounts？',

  serviceAdvantage: 'Service Advantages',
  serviceDesc: "Modao's advantage is to provide you with one-stop overseas payday loan services, from<br>industry experience sharing, license rental/borrowing or application, enterprise start-up<br>recruitment management, setting up the whole process of the system, access to automatic risk<br>control, apps launch, traffic promotion, collection training to the final customs account<br>settlement, Modao has done everything you can think of and more.",

  fastSettle: 'Rapid Start-Up',
  fastSettleDes1: 'Get license rental/borrowing, application, funds-in/funds-out done',
  fastSettleDes2: 'Enterprise registration, overseas holding, initial recruitment',

  systemMakeup: 'Setting Up the Whole Process of the System',
  systemMakeupDes1: 'Client product, product official website, and operation management platform will be launched within one week',
  systemMakeupDes2: 'GoogPlay apps launch, access to automatic risk control',

  planOutput: 'Full Output of Operation Plan',
  planOutputDes1: 'Multi-platform traffic customer acquisition program, the output is measured from one month',
  planOutputDes2: 'Collection, setting-up, training, management',

  dataSafety: 'Data is Safe and Reliable',
  dataSafetyDes1: 'Independent cloud service and cloud data to prevent data leakage',
  dataSafetyDes2: 'Independent products and independent platform operation, the risk is far lower than the saas model',


  //joinus
  togetherWork: 'Work together, Grow up together<br>We need you to join us',
  techType: '技术类',
  backendType: 'Backend Engineer',
  androidType: 'Android Engineer',
  dataType: 'Data Related',
  productType: 'Product Related',
  otherType: '其他职位',
  resumeEmail: 'Please send your resume to shermaine@Xianwen.sg',

  //introduce
  introduceOne: "Xianwen Technology, a leading technology company in the industry, is committed to providing top technology services to partners through information technology and big data AI technology. In the future, Xianwen Technology will seek more partners in the diversified Internet industry, lead the user experience revolution in multiple industries and fields, and better change people's lives.",
  introduceTwo: 'The team members have working experience in BAT, Huawei and other well-known IT and Internet companies at home and abroad. They have rich development and management experience and advantages in technology R&D, data modeling, algorithm analysis, artificial intelligence, financial services, project management, product operation and other fields. They not only have a broad vision and a global thinking model, but also a deep understanding of localization and regional demand.',
  introduceThree: 'There is a large group of passionate, talented, humble, prudent, fun and interesting people, come and join us!',

  ourTeam: 'Our Team',
  ourCulture: 'Company Culture',



}

export default en;


// WEBPACK FOOTER //
// ./src/locale/config/en.js